export default __webpack_public_path__ + "static/logo_header-light-f47add103acbe332b8eed8dce1009b8b.svg";